import { Component, Input } from '@angular/core';

@Component({
    selector: 'ms-speed-reading-result-questions',
    templateUrl: './speed-reading-result-questions.component.html',
    styleUrls: ['./speed-reading-result-questions.component.scss'],
    standalone: false
})
export class SpeedReadingResultQuestionsComponent {
  @Input() value: number | string = '';

  @Input() from: number | string | null = null;
}
